import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";

export interface TermsStatusDto {
  hasAccepted: boolean;
  acceptedVersion: string | null;
  acceptedAtUtc: string | null;
  currentTermsVersion: string;
  currentPrivacyVersion: string;
  requiresReAcceptance: boolean;
  termsUrl: string;
  privacyUrl: string;
  cookiePolicyUrl: string;
  hotelName: string | null;
}

export interface AcceptTermsRequest {
  termsVersion?: string;
}

export interface AcceptTermsResponse {
  success: boolean;
  acceptedAtUtc: string;
  acceptedVersion: string;
}

export interface TermsSettingsDto {
  termsVersion: string;
  privacyVersion: string;
  termsUrl: string;
  privacyUrl: string;
  cookiePolicyUrl: string;
}

export interface AdminTermsServiceInterface {
  getTermsStatus(): Promise<ApiResult<TermsStatusDto>>;
  acceptTerms(request?: AcceptTermsRequest): Promise<ApiResult<AcceptTermsResponse>>;
  getTermsSettings(): Promise<ApiResult<TermsSettingsDto>>;
}

export class AdminTermsService
  extends BaseService
  implements AdminTermsServiceInterface
{
  async getTermsStatus(): Promise<ApiResult<TermsStatusDto>> {
    return this.handleRequest<TermsStatusDto>(
      this.client.get("/api/admin/terms/status")
    );
  }

  async acceptTerms(request?: AcceptTermsRequest): Promise<ApiResult<AcceptTermsResponse>> {
    return this.handleRequest<AcceptTermsResponse>(
      this.client.post("/api/admin/terms/accept", request || {})
    );
  }

  async getTermsSettings(): Promise<ApiResult<TermsSettingsDto>> {
    return this.handleRequest<TermsSettingsDto>(
      this.client.get("/api/admin/terms/settings")
    );
  }
}
